import { gql } from '@apollo/client';

export const GET_USERS_BY_IDS = gql`
  query GET_USERS_BY_IDS($ids: [Int!]!) {
    getUsersByIds(ids: $ids) {
      id
      avatar {
        fileUrl
      }
      profile {
        id
        name
        bio
        collaborationStatus
      }
      professions {
        id
        name
      }
      skills {
        id
        name
      }
    }
  }
`;